import { render, staticRenderFns } from "./ServerManagement.vue?vue&type=template&id=99898e66&"
import script from "./ServerManagement.vue?vue&type=script&lang=js&"
export * from "./ServerManagement.vue?vue&type=script&lang=js&"
import style0 from "./ServerManagement.vue?vue&type=style&index=0&id=99898e66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports